import script from "./CrossChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CrossChart.vue?vue&type=script&setup=true&lang=js"

import "./CrossChart.vue?vue&type=style&index=0&id=2c5e0857&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5e0857"]])

export default __exports__